<template>
  <div class="modal-content">
    <div class="modal-body">
      <billing-customer-details :baseDomain="baseDomain" :shopId="shopId" :apiKey="apiKey" :component="component" v-on:close="hideModal" v-on:save="save" />
    </div>
  </div>
</template>

<script>

import BillingCustomerDetails from '~/components/BillingCustomerDetails'

export default {
  props: ['baseDomain', 'shopId', 'apiKey', 'component'],
  methods: {
    hideModal () {
      this.$emit('close')
    },
    save (data) {
      this.$emit('save', data)
    }
  },
  components: {
    BillingCustomerDetails
  }
}

</script>